import { Component, input, Signal } from '@angular/core';
import { ProductModel } from '../../core/models/user-profile.model';
import { ProductCardComponent } from '../product-card/product-card.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-product-section',
  templateUrl: './product-section.component.html',
  styleUrls: ['./product-section.component.scss'],
  imports: [ProductCardComponent, TranslateModule],
})
export class ProductSectionComponent {
  products: Signal<ProductModel[]> = input();
  isPaired: Signal<boolean> = input();
}
